// src/components/scenarios/ScenarioPanel.js
import React, { useState } from 'react';
import { useScenarios } from '../../context/ScenarioContext';
import { useBioData } from '../../context/BioDataContext';
import ScenarioForm from './ScenarioForm'; // For Bio tab
import PromotionsManager from './PromotionsManager';
import TspContributionCalculator from './TspContributionCalculator';
import AdditionalIncomeForm from './AdditionalIncomeForm';
import SalaryCalculator from '../calculators/SalaryCalculator';
import PensionCalculator from '../calculators/PensionCalculator';
import TspCalculator from '../calculators/TspCalculator';
import SocialSecurityCalculator from '../calculators/SocialSecurityCalculator';

function ScenarioPanel({ scenario }) {
  const { 
    handleScenarioChange, 
    toggleScenarioVisibility, 
    toggleScenarioExpanded,
    removeScenario
  } = useScenarios();
  
  const { calculateRetirementStats } = useBioData();
  // Tab navigation removed as requested

  return (
    <div className="scenario-panel" style={{ borderLeftColor: scenario.color }}>
      <div className="scenario-header">
        <div className="scenario-name-container">
          <input
            type="text"
            value={scenario.name}
            onChange={(e) => handleScenarioChange(scenario.id, 'name', e.target.value)}
            className="scenario-name-input"
          />
          <div className="scenario-controls">
            <span 
              className={scenario.expanded ? 'arrow up' : 'arrow down'} 
              onClick={() => toggleScenarioExpanded(scenario.id)}
              style={{ cursor: 'pointer', marginRight: '15px' }}
            ></span>
            {/* <label className="toggle-label">
              <input
                type="checkbox"
                checked={scenario.visible}
                onChange={() => toggleScenarioVisibility(scenario.id)}
              />
              Show
            </label> */} {/* 'Show' toggle removed as requested */}
            {/* Remove button for scenarios (if more than one exists) */}
            <button 
              className="remove-scenario-btn"
              onClick={() => removeScenario(scenario.id)}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
      
      {scenario.expanded && (
        <div className="scenario-content">
          {/* Scenario configuration form */}
          <ScenarioForm 
            scenario={scenario} 
            calculateRetirementStats={calculateRetirementStats}
          />
          
          {/* Promotions Manager - restored functionality */}
          <PromotionsManager scenario={scenario} />
        </div>
      )}
    </div>
  );
}

export default ScenarioPanel;